import { useRef, useEffect } from "react";
import SEO from "@/components/feature/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotGossipSection from "./components/HotGossipSection";
import LatestArticlesSection from "./components/LatestArticlesSection";
import FeaturedChannelsSection from "./components/FeaturedChannelsSection";

const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "911爆料网",
  "url": "https://911baoliao.com",
  "description": "911爆料网提供全网最新网红黑料、明星八卦、社会奇闻，每日实时更新吃瓜大瓜。",
  "inLanguage": "zh-CN",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://911baoliao.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "911爆料网",
  "url": "https://911baoliao.com",
  "description": "国内领先的娱乐八卦资讯平台",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "400-911-8888",
    "contactType": "customer service",
    "availableLanguage": "Chinese"
  },
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "北京",
    "addressRegion": "朝阳区",
    "streetAddress": "望京SOHO T3-A座 2801室",
    "addressCountry": "CN"
  }
};

export default function Home() {
  const hotGossipRef = useRef<HTMLDivElement>(null);

  const scrollToGossip = () => {
    hotGossipRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      document.title = "911爆料网 | 911爆料吃瓜·911爆料网站·911吃瓜爆料 | 网红黑料实时追踪";
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute("content", "911爆料网提供全网最新网红黑料、明星八卦、社会奇闻，每日实时更新吃瓜大瓜。涵盖911爆料吃瓜、911爆料网站、911吃瓜爆料等热门入口，黑料视频一手掌握。");
    }
  }, []);

  return (
    <>
      <SEO
        schema={{ ...homepageSchema, ...{ "@graph": [homepageSchema, orgSchema] } }}
      />
      <Navbar />
      <main>
        <HeroSection scrollToSection={scrollToGossip} />
        <div ref={hotGossipRef}>
          <HotGossipSection />
        </div>
        <LatestArticlesSection />
        <FeaturedChannelsSection />
      </main>
      <Footer />
    </>
  );
}